import LeadCreationStepper from "../layout/driverLeadCreation/LeadCreationStepper";
import PageLayout from "./PageLayout";

const DriverLeadCreationPage = () => {
  return (
    <PageLayout sx={{ px: 0, py: 0 }}>
      <LeadCreationStepper />
    </PageLayout>
  );
};

export default DriverLeadCreationPage;
